<div class="row">
  <div class="col-lg-6">
    <div class='info-column'>
      <div class='info-section'>
        <h5 class='info-title'>
          App Information
          <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
            data-animation="false" title="Detailed app specific information.">
            <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
          </a>
        </h5>
        <div class='info-list-2'>
          <info-list-item label='App ID' [value]='data?.overview?.appId'></info-list-item>
          <info-list-item label='Store URL' value='Go to Store' [link]='data?.appInfo?.storeUrl'
            [valueTooltip]='data?.appInfo?.storeUrl'></info-list-item>
          <info-list-item label='Owner Domain' [lock]='isFreemium'
            labelTooltip="Business domain of the owner of the app, as declared in the corresponding app-ads.txt file.">
            <ng-container #value>
              <ng-container *ngIf="(!data?.overview?.ownerDomain
                || data?.overview?.ownerDomain === 'N/A'); else showOwnerDomainLink">
                N/A
              </ng-container>
              <ng-template #showOwnerDomainLink>
                <a class="btn btn-link p-0 external-link" target="_blank"
                  href="{{data?.overview?.ownerDomain | urlfix}}">
                  <span>{{data?.overview?.ownerDomain}} </span>
                  <i class="fa fa-external-link"></i>
                </a>
              </ng-template>
            </ng-container>
          </info-list-item>

          <info-list-item label='Available Countries'>

            <ng-container #value>
              <ng-container *ngIf="isFreemium || data?.appInfo?.availableCountries?.length > 0">
                <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
                  <ng-container *ngIf="_userService.ottDiscoveryEnabled()">
                    <a class="btn btn-link p-0" style="white-space: nowrap"
                      *ngFor="let country of data?.appInfo?.availableCountries; let i = index;"
                      (click)="toAppDiscoveryClick({param: 'appAvailableCountry', paramValue : country?.countryName})">
                      <img class="flag" src="//cdn.pixalate.com/icons/countries/flat/48/{{country?.countryCode}}.png"
                        alt="Flag Icon" title="{{country?.countryName}}" data-animation="false" />
                      <span *ngIf="i < data?.appInfo?.availableCountries?.length - 1">&nbsp;</span>
                    </a>
                  </ng-container>
                  <ng-container *ngIf="!_userService.ottDiscoveryEnabled()">
                    <div class="d-inline-block"
                      *ngFor="let country of data?.appInfo?.availableCountries; let i = index;">
                      <img class="flag" src="//cdn.pixalate.com/icons/countries/flat/48/{{country?.countryCode}}.png"
                        alt="Flag Icon" title="{{country?.countryName}}" data-animation="false" />
                      <span *ngIf="i < data?.appInfo?.availableCountries?.length - 1">&nbsp;</span>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="isFreemium && !isFollowing">
                  <div class="value text-capitalize">
                    <div class="freemium-lock">
                      <i class="fa fa-lock"></i>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container
                *ngIf="!isFreemium && (!data?.appInfo?.availableCountries || data?.appInfo?.availableCountries?.length <= 0)">
                N/A
              </ng-container>
            </ng-container>
          </info-list-item>

          <info-list-item label='Language Available'>

            <ng-container #value>
              <ng-container *ngIf="isFreemium || data?.appInfo?.availableLanguages?.length > 0">
                <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
                  <ng-container *ngIf="_userService.ottDiscoveryEnabled()">
                    <a class="btn btn-link p-0" style="white-space: nowrap"
                      *ngFor="let lang of data?.appInfo?.availableLanguages; let i = index;"
                      (click)="toAppDiscoveryClick({param: 'appAvailableLanguage', paramValue : lang?.langName})">
                      {{lang?.langName}}<span *ngIf="i < data?.appInfo?.availableLanguages?.length - 1">,&nbsp;</span>
                    </a>
                  </ng-container>
                  <ng-container *ngIf="!_userService.ottDiscoveryEnabled()">
                    <div class="d-inline-block" *ngFor="let lang of data?.appInfo?.availableLanguages; let i = index;">
                      {{lang?.langName}}<span *ngIf="i < data?.appInfo?.availableLanguages?.length - 1">,&nbsp;</span>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="isFreemium && !isFollowing">
                  <div class="value text-capitalize">
                    <div class="freemium-lock">
                      <i class="fa fa-lock"></i>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container
                *ngIf="!isFreemium && (!data?.appInfo?.availableLanguages || data?.appInfo?.availableLanguages?.length <= 0)">
                N/A
              </ng-container>
            </ng-container>
          </info-list-item>

          <info-list-item label='Keywords' labelTooltip='Search terms and keywords typically associated to the app.'>

            <ng-container #value>
              <ng-container *ngIf="isFreemium || data?.appInfo?.keywords?.length > 0">
                <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
                  <ng-container *ngIf="_userService.ottDiscoveryEnabled()">
                    <a class="btn btn-link p-0" style="white-space: nowrap"
                      *ngFor="let keyword of data?.appInfo?.keywords; let i = index;"
                      (click)="toAppDiscoveryClick({param: 'keyword', paramValue : keyword.toLowerCase()})">
                      {{keyword}}<span *ngIf="i < data?.appInfo?.keywords?.length - 1">,&nbsp;</span>
                    </a>
                  </ng-container>
                  <ng-container *ngIf="!_userService.ottDiscoveryEnabled()">
                    <div class="d-inline-block" *ngFor="let keyword of data?.appInfo?.keywords; let i = index;">
                      {{keyword}}<span *ngIf="i < data?.appInfo?.keywords?.length - 1">,&nbsp;</span>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="isFreemium && !isFollowing">
                  <div class="value text-capitalize">
                    <div class="freemium-lock">
                      <i class="fa fa-lock"></i>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="!isFreemium && ( !data?.appInfo?.keywords || data?.appInfo?.keywords?.length <= 0)">
                N/A
              </ng-container>
            </ng-container>
          </info-list-item>

          <info-list-item label="App's Privacy Policy"
            labelTooltip='Indicates whether an app-specific privacy policy is maintained. Apps which do not maintain a privacy policy may be of higher risk to advertisers and sellers.'>

            <ng-container #value>
              <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
                <ng-container *ngIf="data?.appInfo?.hasPrivacyLinkInAppStore !== 'N/A'">
                  <img src="/assets/images/icon-indicator-{{data?.appInfo?.hasPrivacyLinkInAppStore | yesno}}-2.svg"
                    alt="Info Icon" />
                  {{data?.appInfo?.hasPrivacyLinkInAppStore | yesno:"capitalize"}}
                </ng-container>
                <ng-container *ngIf="data?.appInfo?.hasPrivacyLinkInAppStore &&
              data?.appInfo?.hasPrivacyLinkInAppStore !== 'N/A' && data?.riskOverview?.privacyPolicyUrl &&
              data?.riskOverview?.privacyPolicyUrl !== 'N/A'">
                  <a class="btn btn-link p-0 external-link" target="_blank"
                    href="{{data?.riskOverview?.privacyPolicyUrl | urlfix}}">
                    <span>view policy </span><i class="fa fa-external-link"></i>
                  </a>
                </ng-container>
              </ng-container>
              <ng-container *ngIf="isFreemium && !isFollowing">
                <div class="value text-capitalize">
                  <div class="freemium-lock">
                    <i class="fa fa-lock"></i>
                  </div>
                </div>
              </ng-container>
            </ng-container>
          </info-list-item>

          <info-list-item label="Revenue Sources"
            labelTooltip='The primary source of revenue (e.g., ads, in-app subscriptions, etc.), as cited within the app store.'>

            <ng-container #value>
              <ng-container *ngIf="isFreemium || data?.appInfo?.revenueSources?.length > 0">
                <ng-container *ngIf="!isFreemium || (isFreemium && isFollowing)">
                  <ng-container *ngIf="_userService.ottDiscoveryEnabled()">
                    <a class="btn btn-link p-0"
                      *ngFor="let revenueSource of data?.appInfo?.revenueSources; let i = index;"
                      style="white-space: nowrap"
                      (click)="toAppDiscoveryClick({param: 'revenueSource', paramValue : revenueSource})">
                      {{revenueSource}}<span *ngIf="i < data?.appInfo?.revenueSources?.length - 1">,&nbsp;</span>
                    </a>
                  </ng-container>
                  <ng-container *ngIf="!_userService.ottDiscoveryEnabled()">
                    <div class="d-inline-block"
                      *ngFor="let revenueSource of data?.appInfo?.revenueSources; let i = index;">
                      {{revenueSource}}<span *ngIf="i < data?.appInfo?.revenueSources?.length - 1">,&nbsp;</span>
                    </div>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="isFreemium && !isFollowing">
                  <div class="value text-capitalize">
                    <div class="freemium-lock">
                      <i class="fa fa-lock"></i>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
              <ng-container
                *ngIf="!isFreemium && (!data?.appInfo?.revenueSources || data?.appInfo?.revenueSources?.length <=0)">
                N/A
              </ng-container>
            </ng-container>
          </info-list-item>

          <info-list-item label="CVAA Compliant"
            (valueInteract)='_userService.ottDiscoveryEnabled() ? toAppDiscoveryClick({param: "isCvaaCompliant", paramValue: data?.appInfo?.isCvaaCompliant ? "T" : "F" }) : null'
            [lock]='isFreemium && !isFollowing'
            labelTooltip="Indicates whether the app is in compliance with the FCC's Communications and Video Accessibility Act (CVAA) Standards. Compliance with CVAA Standards is required across premium OTT/CTV Video on Demand (VoD) content (e.g., TVoD), Subscription VoD (SVoD) content, and content delivered via traditional cable outlets.">

            <ng-container #value>
              <ng-container *ngIf="data?.appInfo?.isCvaaCompliant !== 'N/A'">
                <img src="/assets/images/icon-indicator-{{data?.appInfo?.isCvaaCompliant | yesno}}-2.svg"
                  alt="Info Icon" />
                {{data?.appInfo?.isCvaaCompliant | yesno:"capitalize"}}
              </ng-container>
              <ng-container *ngIf="data?.appInfo?.isCvaaCompliant === 'N/A'">
                {{data?.appInfo?.isCvaaCompliant}}
              </ng-container>
            </ng-container>
          </info-list-item>

          <info-list-item label="App Age"
            labelTooltip="The amount of time the app has been listed within the app store. Apps which have been listed for an extended period of time may present less risk than those recently published.">

            <ng-container #value>
              {{data?.appInfo?.appAge | monthstoyears}}
              <risk-heat-meter
                (interact)='_userService.ottDiscoveryEnabled() ? toAppDiscoveryClick({param: "appAgeRisk", paramValue : data?.appInfo?.appAgeRisk}) : null'
                [risk]='data?.appInfo?.appAgeRisk'></risk-heat-meter>
            </ng-container>
          </info-list-item>

          <info-list-item label="Published Date" labelTooltip="The date of original publication within the app store.">

            <ng-container #value>
              <ng-container *ngIf="data?.appInfo?.publishedDate !== 'N/A'">
                {{data?.appInfo?.publishedDate | date}}
              </ng-container>
              <ng-container *ngIf="data?.appInfo?.publishedDate === 'N/A'">
                N/A
              </ng-container>
            </ng-container>
          </info-list-item>

        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-6" *ngIf="isFreemium || bundleIds?.length > 0">
    <div class="pr-0 info-list bundle-list">
      <h3 class="sub-title">
        Bundle ID
        <a class="btn btn-link help-icon p-0" data-placement="top" data-toggle="tooltip" enTooltip
          data-animation="false" title="The unique textual identifier of the app within the app store. ">
          <img src="/assets/images/icon-indicator-info-2.svg" alt="Info Icon" />
        </a>
      </h3>
      <div class="d-flex info-list-item">
        <div class="label"></div>
        <div class="value font-weight-600">SOV</div>
      </div>
      <div class="divider"></div>
      <ng-container *ngFor="let bundleId of bundleIds; let i = index;">
        <div class="d-flex info-list-item" *ngIf="i < (showMore ? bundleIds?.length : 10) ">
          <div class="label">
            <a [attr.title]="bundleId?.appId">
              {{bundleId?.appId}}
            </a>
          </div>
          <div class="value" enAnonLock>
            {{bundleId?.totalTrafficRatio | perc:'1.2-2' }} </div>
        </div>
        <div class="divider" *ngIf="i < (showMore ? bundleIds?.length -1 : 9)"></div>
      </ng-container>
      <button *ngIf="data?.appInfo?.bundleIds?.length > 10" class="btn btn-secondary show-more w-100"
        (click)="showMore = !showMore">
        {{showMore ? 'Show Less' : 'Show More'}}
      </button>
    </div>
  </div>
</div>
<app-follow-unlock label="Additional App Details" (followClick)="follow()"
  *ngIf="!isFollowing && isFreemium"></app-follow-unlock>